import { convertToRaw, EditorState, RawDraftContentBlock, RawDraftEntityRange } from 'draft-js'

/**
 * @param editorState
 */
export default function appendWhiteSpaceToEndOfAllMentions(editorState: EditorState) {
  const rawEditorContent = convertToRaw(editorState.getCurrentContent())
  rawEditorContent.blocks.forEach((block: RawDraftContentBlock) => {
    block.entityRanges.reverse().forEach((entity: RawDraftEntityRange) => {
      const nextCharacter = block.text[entity.offset + entity.length]
      const nextCharacterDenotesEndOfMention = new RegExp(/[\s!"')*,.?\\}]/).test(nextCharacter)
      if (rawEditorContent.entityMap[entity.key].data.mention) {
        block.text =
          block.text.slice(0, Math.max(0, entity.offset)) +
          `${rawEditorContent.entityMap[entity.key].data.mention.name}${nextCharacterDenotesEndOfMention ? '' : ' '}` +
          block.text.slice(Math.max(0, entity.offset + entity.length))
      }
    })
  })

  return rawEditorContent
}
